<template>
  <!--- per-page prop will become perPage according to Vue standard -->
  <VuePagination2
    v-model="page"
    :records="records"
    :per-page="perPage"
    @paginate="$emit('paginate', $event)"
    :options="options"
  />
</template>

<script>
import VuePagination2 from "vue-pagination-2";

export default {
  name: "Pagination",
  components: {
    VuePagination2
  },
  model: {
    prop: "current_page",
    event: "changed-current-page"
  },
  props: {
    placement: {
      type: String,
      default: ""
    },
    current_page: {},
    records: {},
    "per-page": {},
    options: {}
  },
  computed: {
    page: {
      get: function() {
        return this.current_page;
      },
      set: function(new_value) {
        this.$emit("changed-current-page", new_value);
      }
    }
  }
};
</script>
<style>
.bookings-pages-cont .VuePagination:first-child .VuePagination__count::before,
.bookings-pages-cont .VuePagination:first-child ul::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 0;
  border-bottom: 1px solid #b1b6d1;
  left: 0;
  bottom: 0;
}
.bookings-pages-cont .VuePagination:last-child .VuePagination__count::before,
.bookings-pages-cont .VuePagination:last-child ul::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 0;
  border-bottom: 1px solid #b1b6d1;
  left: 0;
  top: 0;
}
.VuePagination {
  position: relative;
}
.VuePagination nav {
  display: flex;
  justify-content: flex-start;
  flex-direction: row-reverse;
  align-items: center;
}
ul.VuePagination__pagination {
  margin: 0;
  display: flex;
  align-items: center;
  padding: 5px;
}
ul.VuePagination__pagination li {
  margin: 0 1px;
}
ul.VuePagination__pagination li a.page-link {
  padding: 5px 10px;
  color: #7c7d9c !important;
  border: 1px solid transparent;
  border-radius: 5px;
}
ul.VuePagination__pagination li a.page-link.active {
  color: #131336 !important;
  border: 1px solid #567bf3;
  background-color: #eff3fb;
  font-family: "RubikMed" !important;
}

ul.VuePagination__pagination li a.page-link:hover {
  text-decoration: none !important;
  border: 1px solid #b1b6d1;
  background-color: #eff3fb;
}
ul.VuePagination__pagination li a.page-link.active:hover {
  color: #131336 !important;
  border: 1px solid #567bf3;
  cursor: default;
}
ul.VuePagination__pagination li a.page-link[disabled] {
  cursor: not-allowed !important;
  background-color: transparent;
  border-color: transparent;
  opacity: 0.5;
}
p.VuePagination__count {
  margin: 5px 10px;
  color: #7c7d9c;
}
</style>
